<template>
  <div class="mb-8">
      <div v-if="company.status === 'Prospect'">
        <h2>Radera prospectet</h2>
        <p>Detta alternativ används när prospectet varit inaktivt i 2 år. Görs i huvudsak automatiskt.</p>
        <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="company.gdpr_prospect_inactive_at">Prospectet blev raderat: <b>{{ company.gdpr_prospect_inactive_at }}</b></div>
        <button  class="btn btn-danger" @click="prospectInactive()" :disabled="prospectInactive_submitted">Radera prospect</button>
      </div>
      <div v-if="company.status === 'Avslutad'">
        <h2>Radera företaget</h2>
        <p>Detta alternativ används för att radera en partner 7 år efter avslutat avtal. Görs i huvudsak automatiskt.</p>
        <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="company.gdpr_disconnected_7_year_at">Företaget raderades: <b>{{ company.gdpr_disconnected_7_year_at }}</b></div>
        <button  class="btn btn-danger" @click="deleteDisconnected()" :disabled="deleteDisconnected_submitted">Radera företag</button>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {

    props: {
        company: {
            required: true
        }
    },

    data () {
        return {
            prospectInactive_submitted: false,
            deleteDisconnected_submitted: false
        }
    },

    methods: {
        prospectInactive () {
            if (this.prospectInactive_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för prospectet?')) {
                return
            }

            this.prospectInactive_submitted = true

            axios.post(
                '/companies/' + this.company.id + '/gdpr/prospectInactive'
            )
                .then(response => {
                    console.log('prospectInactive')
                    console.log(response.data)

                    bus.$emit('notify', 'Företaget är raderad.')
                    location.reload()
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        deleteDisconnected () {
            if (this.deleteDisconnected_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för det avlsutade företaget?')) {
                return
            }

            this.deleteDisconnected_submitted = true

            axios.post(
                '/companies/' + this.company.id + '/gdpr/deleteDisconnected'
            )
                .then(response => {
                    console.log('prospectInactive')
                    console.log(response.data)

                    bus.$emit('notify', 'Företaget är raderad.')
                    location.reload()
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }

}
</script>
